import { Component, NgModule, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Email, UserModel } from '../../shared/models/user.model';
import { AuthService } from '../../shared/services/auth.service';
import Swal from 'sweetalert2';
import { CoreService } from '../../shared/services/core.service';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { IClubInvite, ILeagueInvite } from '../../shared/models/club.model';
// import {parsePhoneNumberFromString,  CountryCode,getCountryCallingCode } from 'libphonenumber-js';
@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css'],
})
export class RegisterComponent implements OnInit {
  id: string | null = null;
  registerUser: UserModel = new UserModel();
  errorMessage: string = "";
  jsonData: any;
  emailmodel: Email = new Email();
  today: string;
  hidePassword: boolean = true;
  hideConfirmPassword: boolean = true;

  constructor(private fb: FormBuilder, private auth: AuthService, private route: ActivatedRoute, private router: Router, private coreService: CoreService) {
    const currentDate = new Date();
    this.today = currentDate.toISOString().split('T')[0];
  }

  ngOnInit(): void {
    this.auth.logOut();
    this.route.queryParams.subscribe((params: any) => {
  this.id = params?.id;

  const isCombined = params?.isCombined;
  const leagueId = params?.leagueId;
  const clubId = params?.clubId;

  console.log("REGISTER PARAMS:", { isCombined, leagueId, clubId });

  // ❌ IMPORTANT FIX
  if (isCombined && leagueId && clubId) {
    console.log("🚫 Skipping getInvitationDetails (combined flow)");
    this.getLeagueDetails();
  }
  else if (this.id) {
    this.getInvitationDetails();
  }
});
    this.auth.emailObs$.subscribe((emailmodel: Email) => {
      this.emailmodel = emailmodel;
      // this.registerForm.get('email')?.setValue("")=emailmodel.email;
      if (emailmodel?.email) {
        this.registerForm.get('email')?.setValue(emailmodel.email);
      }
    });
  }

  getInvitationDetails() {
    this.coreService.isLoading.next(true);
    this.coreService.getApi('/api/Club/GetInvitationDetails?encryptedData=' + this.id).subscribe({
      next: (res: IClubInvite) => {
        this.coreService.isLoading.next(false);
        if (res.email) {
          this.registerForm.get('email')?.setValue(res.email);
        }
        if (res.isValidUser) {
          this.router.navigate(['/login'], { queryParams: { id: this.id } });
        }
      },
      error: (error) => {
        this.coreService.isLoading.next(false);
      },
    });
  }

   getLeagueDetails() {
      this.coreService.isLoading.next(true);
      this.coreService.getApi('/api/League/GetLeagueInvitationDetails?encryptedData=' + this.id).subscribe({
        next: (res: ILeagueInvite) => {
          this.coreService.isLoading.next(false);
          if (res.email) {
          this.registerForm.get('email')?.setValue(res.email);
        }
        if (res.isValidUser) {
          this.router.navigate(['/login'], { queryParams: { id: this.id } });
        }
        },
        error: (error) => {
          this.coreService.isLoading.next(false);
        },
      });
    }

  isConfirmpasswordError = (control: any) => {
    const password = control.get('password');
    const confirmpassword = control.get('confirmpassword');

    if (password && confirmpassword && password.value !== confirmpassword.value) {
      return { 'passwordMismatch': true };
    }

    return null;
  };
  registerForm = this.fb.group({
    first_name: ['', [Validators.required, Validators.pattern(/^[a-zA-Z]+(?: [a-zA-Z]+)*$/)]],
    last_name: ['', [Validators.required, Validators.pattern(/^[a-zA-Z]+(?: [a-zA-Z]+)*$/)]],
    // email: ['', [Validators.required, Validators.pattern(/@(?:gmail|outlook)\.com$/)]],
    email: ['', [Validators.required,  Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[cC][oO][mM]$/)]],
    password: ['', [Validators.required, Validators.minLength(6)]],
    confirmpassword: ['', Validators.required],
    // phone_number:['', Validators.required],
    phoneNumber: ['', Validators.required],
    gender: ['', Validators.required],
    zip: ['', [Validators.required,Validators.pattern(/^\d{5}$/) ]],
    dob: ['', Validators.required],
  }, { validators: this.isConfirmpasswordError });


  get first_name() { return this.registerForm.controls['first_name']; }
  get last_name() { return this.registerForm.controls['last_name']; }
  get email() { return this.registerForm.controls['email']; }
  get password() { return this.registerForm.controls['password']; }
  get confirmpassword() { return this.registerForm.controls['confirmpassword']; }
  // get phone_number(){return this.registerForm.controls['phone_number'];}
  get gender() { return this.registerForm.controls['gender']; }
  get dob() { return this.registerForm.controls['dob']; }
  get phoneNumber() { return this.registerForm.controls['phoneNumber']; }
  get zip() { return this.registerForm.controls['zip']; }
  gendervaue: any;
  // phoneNumber: string = '';
  showPhoneNumberError: boolean = false;
  checkInput() {
    console.log(this.registerForm.get('dob')?.value);
    // console.log(this.registerForm.get('first_name')?.value);
    this.gendervaue = this.registerForm.get('dob')?.value;
  }
  phoneNum: any;
  formatPhoneNumber(event: any) {
    let phoneNumber = event.target.value.replace(/\D/g, ''); // Remove non-digit characters
    if (phoneNumber.length > 3) {
      // Insert hyphen after the third character
      phoneNumber = phoneNumber.substring(0, 3) + '-' + phoneNumber.substring(3);
    }

    // Check if phoneNumber is not empty and is greater than 7 characters
    if (phoneNumber.length > 7) {
      // Insert hyphen after the sixth character
      phoneNumber = phoneNumber.substring(0, 7) + '-' + phoneNumber.substring(7);
    }
    event.target.value = phoneNumber;
    this.phoneNum = phoneNumber;
    // Check if the phone number is not empty and show/hide the error message accordingly
    this.showPhoneNumberError = phoneNumber.length > 0 && phoneNumber.replace(/\D/g, '').length !== 10;

  }

  onZipInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const zipValue = (input.value || '').replace(/\D/g, '').slice(0, 5);
    input.value = zipValue;
    this.registerForm.get('zip')?.setValue(zipValue, { emitEvent: false });
  }

  onRegister() {
    if (!this.registerForm.valid) {
      alert('Please fill in all required fields correctly.');
      return;
    }
    this.validateEmail();
    if (!this.email.valid) {
      return;
    }
    this.registerUser = {
      id: 0,
      userName: `${this.registerForm.get('first_name')?.value} ${this.registerForm.get('last_name')?.value}`,
      firstName: `${this.registerForm.get('first_name')?.value}`,
      lastName: `${this.registerForm.get('last_name')?.value}`,
      email: `${this.registerForm.get('email')?.value}`,
      password: `${this.registerForm.get('password')?.value}`,
      phoneNumber: `${this.registerForm.get('phoneNumber')?.value?.replace(/\D/g, '')}`,
      gender: `${this.registerForm.get('gender')?.value}`,
      zip: `${this.registerForm.get('zip')?.value}`,
      dateOfBirth: new Date(`${this.registerForm.get('dob')?.value}`),
      isSuccess: false,
      message: [],
      token: '',
    };
    console.log(this.registerUser);
    this.auth.register(this.registerUser).pipe(first()).subscribe(
      (message: string) => {
        if (message.toLowerCase().includes('success')) {
          Swal.fire({
  icon: 'success',
  title: 'Registered Successfully',
  text: message,
  showCancelButton: true,
  confirmButtonText: 'login.'
}).then(result => {
  if (result.isConfirmed) {

    const leagueId = this.route.snapshot.queryParams['leagueId'];
    const clubId = this.route.snapshot.queryParams['clubId'];
    const isCombined = this.route.snapshot.queryParams['isCombined'];

    if (this.id) {

      // 🔥 Invite flow
      if (isCombined) {
        this.router.navigate(['login'], { 
          queryParams: { 
            id: this.id,
            leagueId: leagueId,
            clubId: clubId,
            isCombined: true
          } 
        });
      } 

      // ✅ Normal flow
      else {
        this.router.navigate(['login'], { 
          queryParams: { id: this.id } 
        });
      }

    } else {
      this.router.navigate(['login']);
    }

  }
});
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Registration Failed',
            text: message
          });
        }
      },
      (err) => {
        Swal.fire('Oops...', 'Something went wrong, please try again', 'error');
      }
    );
  }
  validateEmail() {
    const email = this.registerForm.get('email');
    if (email && email.invalid && email.dirty) {
      // If the email is invalid and has been touched, display the alert box
      alert('Please provide a valid Gmail address (ending with @gmail.com/@outlook.com)');
    }
  }

}

